// extracted by mini-css-extract-plugin
module.exports = {"main":"main-view_main_2Wuv8","mainWrap":"main-view_mainWrap_1Y0RX","leftMain":"main-view_leftMain_1bcWZ","rightMain":"main-view_rightMain_yaR-l"};